var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.2485 6.35147c.4687.46863.4687 1.22843 0 1.69706l-3.9514 3.95147 3.9514 3.9515c.4687.4686.4687 1.2284 0 1.697-.4686.4687-1.2284.4687-1.697 0l-4.80003-4.8c-.46863-.4686-.46863-1.2284 0-1.697l4.80003-4.80003c.4686-.46863 1.2284-.46863 1.697 0z",
    fill: "#3703a4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.bcb0f2954ba47ed4e1945d4a7c4d4a30.svg";
export { ForwardRef as ReactComponent };